import { Link } from "react-router-dom";
import React, { useState } from "react";
import { auth } from "../util/nhost";
import MainLayout from "../components/layout/mainLayout";
import AuthWrapper from "./authWrapper";
import BottomNotification from "../components/notification/bottomNotification";
import { useNavigate } from "react-router";
import ScreenLoading from "../components/global/screenLoading";
import { wrongEmail } from "../components/global/wrongEmail";
import { validateEmail } from "../components/global/validateEmail";
import useAnalyticsEventTracker from "../hooks/useAnalyticsEventTracker";
import ReactGA from "react-ga4";

const RegisterPage = () => {
  const gaEventTracker = useAnalyticsEventTracker("authentication");

  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rnd, setRnd] = useState();
  const [notification, setNotification] = useState("");
  const [notificationType, setNotificationType] = useState("alert-info");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const handleRegister = async () => {
    gaEventTracker("register");
    setLoading(true);
    setRnd((rnd) => Math.floor(Math.random() * 10 + 1));

    try {
      await auth.register({
        email,
        password,
        options: {
          userData: {
            display_name: name,
          },
        },
      });
    } catch (error) {
      setLoading(false);
      ReactGA.event({
        category: "register",
        action: "register_failed",
      });

      setNotificationType("alert-error");
      return setNotification(error.response.data.message);
    }
    setTimeout(() => {
      ReactGA.event({
        category: "register",
        action: "registered",
      });
      setLoading(false);
      setNotificationType("alert-info");
      setNotification("You registered successfully");
      setTimeout(() => {
        navigate("/");
      }, 400);
    }, 700);
  };
  return (
    <MainLayout>
      <AuthWrapper
        header="Register"
        desc="Please register to get the most out of VideoBit. It’s 100% free."
        footer={
          <span>
            Already have an account?{" "}
            <Link to="/login" className="link link-primary">
              Log in
            </Link>
          </span>
        }>
        <div className="card-body">
          <div className="form-control">
            <label className="label">
              <span className="label-text">Name</span>
            </label>
            <input
              type="text"
              placeholder="first name"
              className="input input-bordered"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="form-control">
            <label className="label">
              {wrongEmail(email)}
              <span className="label-text">Email</span>
            </label>
            <input
              type="text"
              placeholder="email"
              className="input input-bordered"
              required
              value={email}
              autoComplete="new-password"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-control relative">
            <label className="label">
              <span className="label-text">Password</span>
            </label>

            <input
              type={showPass ? "text" : "password"}
              placeholder="password"
              className="input input-bordered"
              required
              value={password}
              autoComplete="new-password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <label className="swap  btn btn-ghost  btn-circle absolute top-9 right-1">
              <input
                type="checkbox"
                checked={showPass ? true : false}
                onChange={(e) => setShowPass(!showPass)}
              />

              <svg
                className=" swap-off fill-current w-6 h-6"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_102_26)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.97687 12C4.05967 12.1406 4.16263 12.3093 4.28527 12.4992C4.66556 13.088 5.2285 13.8706 5.95862 14.6494C7.4371 16.2264 9.48276 17.6667 11.9999 17.6667C14.5171 17.6667 16.5627 16.2264 18.0412 14.6494C18.7713 13.8706 19.3343 13.088 19.7146 12.4992C19.8372 12.3093 19.9402 12.1406 20.023 12C19.9402 11.8594 19.8372 11.6908 19.7146 11.5009C19.3343 10.912 18.7713 10.1294 18.0412 9.35062C16.5627 7.77357 14.5171 6.33334 11.9999 6.33334C9.48276 6.33334 7.4371 7.77357 5.95862 9.35062C5.2285 10.1294 4.66556 10.912 4.28527 11.5009C4.16263 11.6908 4.05967 11.8594 3.97687 12ZM21.1666 12C22.061 11.5528 22.0608 11.5525 22.0607 11.5521L22.0602 11.5513L22.0592 11.5491L22.0561 11.543L22.0462 11.5237C22.038 11.5076 22.0264 11.4854 22.0116 11.4574C21.982 11.4014 21.9392 11.3223 21.8835 11.2233C21.7722 11.0254 21.6088 10.7474 21.3946 10.4158C20.9676 9.75466 20.3327 8.87061 19.5003 7.98274C17.8538 6.22645 15.3161 4.33334 11.9999 4.33334C8.68374 4.33334 6.14607 6.22645 4.49955 7.98274C3.66717 8.87061 3.03219 9.75466 2.60519 10.4158C2.39107 10.7474 2.22761 11.0254 2.1163 11.2233C2.0606 11.3223 2.01785 11.4014 1.98823 11.4574C1.97342 11.4854 1.96188 11.5076 1.95364 11.5237L1.94375 11.543L1.94067 11.5491L1.93959 11.5513L1.93917 11.5521C1.93899 11.5525 1.93882 11.5528 2.83325 12L1.93882 11.5528C1.79806 11.8343 1.79806 12.1657 1.93882 12.4472L2.83325 12C1.93882 12.4472 1.93899 12.4476 1.93917 12.4479L1.93959 12.4488L1.94067 12.4509L1.94375 12.457L1.95364 12.4764C1.96188 12.4924 1.97342 12.5146 1.98823 12.5426C2.01785 12.5986 2.0606 12.6777 2.1163 12.7767C2.22761 12.9746 2.39107 13.2527 2.60519 13.5842C3.03219 14.2454 3.66717 15.1294 4.49955 16.0173C6.14607 17.7736 8.68374 19.6667 11.9999 19.6667C15.3161 19.6667 17.8538 17.7736 19.5003 16.0173C20.3327 15.1294 20.9676 14.2454 21.3946 13.5842C21.6088 13.2527 21.7722 12.9746 21.8835 12.7767C21.9392 12.6777 21.982 12.5986 22.0116 12.5426C22.0264 12.5146 22.038 12.4924 22.0462 12.4764L22.0561 12.457L22.0592 12.4509L22.0602 12.4488L22.0607 12.4479C22.0608 12.4476 22.061 12.4472 21.1666 12ZM21.1666 12L22.061 12.4472C22.2018 12.1657 22.2018 11.8343 22.061 11.5528L21.1666 12Z"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12Z"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_102_26">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(2 2)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                className=" swap-on fill-current w-6 h-6">
                <g clipPath="url(#clip0_103_39)">
                  <path d="M2.58293 10.5611C2.35854 10.6344 2.1878 10.7982 2.06585 11.0597C2.00732 11.1843 2 11.2283 2 11.4678C2 11.7073 2.00732 11.7512 2.06341 11.871C2.1878 12.1349 2.65366 12.7068 3.19024 13.2566C3.40732 13.4766 3.5 13.589 3.48537 13.611C3.47561 13.6281 3.16098 14.0729 2.7878 14.5983C2.41463 15.1261 2.10976 15.5709 2.1122 15.588C2.11463 15.6295 3.29512 16.7464 3.33415 16.7464C3.36341 16.7464 3.42439 16.6608 4.31463 15.4096C4.57805 15.0357 4.80244 14.7278 4.8122 14.7229C4.82195 14.7156 4.96585 14.8109 5.13415 14.9306C5.52195 15.2092 6.0122 15.5098 6.53171 15.7884C6.89268 15.9815 6.94146 16.0157 6.92927 16.0597C6.92195 16.089 6.73902 16.6706 6.52439 17.3549C6.3122 18.0416 6.14146 18.6061 6.14634 18.6134C6.16341 18.6281 7.65366 19.2512 7.65854 19.2439C7.66098 19.2415 7.84634 18.6501 8.07073 17.9316C8.29756 17.2131 8.48537 16.6193 8.49024 16.6144C8.49512 16.6095 8.61707 16.6388 8.76098 16.6804C9.28049 16.827 9.89512 16.9468 10.5 17.0152C10.6805 17.0347 10.8488 17.0518 10.8732 17.0518C10.9122 17.0518 10.9146 17.1374 10.9146 18.4815V19.9111H11.7195H12.5244V18.4839V17.0567L12.7024 17.0396C13.4293 16.9712 14.1585 16.8343 14.8244 16.6388L14.9902 16.59L15.0122 16.6437C15.0244 16.673 15.2122 17.2644 15.4293 17.956C15.6463 18.6476 15.8268 19.2195 15.8317 19.2244C15.8415 19.2341 17.3073 18.6207 17.3341 18.5939C17.3512 18.5792 17.2659 18.3031 16.7317 16.612C16.6317 16.2967 16.5488 16.0254 16.5488 16.0083C16.5488 15.9937 16.6976 15.9033 16.878 15.8079C17.322 15.5758 17.7585 15.3119 18.1707 15.0259C18.3585 14.8964 18.5244 14.7816 18.5415 14.7718C18.5585 14.7596 18.8195 15.1115 19.2829 15.7737C19.6756 16.3358 20.0049 16.805 20.0146 16.8148C20.0366 16.8417 21.2683 15.6882 21.2659 15.6442C21.2634 15.6271 20.9537 15.1726 20.5756 14.6349C20.2 14.0973 19.8902 13.6501 19.8902 13.6403C19.8902 13.6305 20.0537 13.457 20.2512 13.2517C20.8 12.6921 21.2634 12.1178 21.3829 11.8563C21.4293 11.7561 21.439 11.695 21.439 11.4678C21.439 11.2161 21.4341 11.1892 21.361 11.0352C21.178 10.6467 20.8098 10.4536 20.4488 10.5587C20.2585 10.6149 20.1366 10.7175 19.9195 10.9986C19.3805 11.6975 18.6439 12.4208 17.8537 13.0318C15.5829 14.784 12.9488 15.5074 10.3049 15.1066C8.43659 14.8231 6.64634 13.9604 5.02927 12.5675C4.5878 12.1887 3.91707 11.4995 3.63415 11.1379C3.35854 10.7835 3.22927 10.6564 3.09024 10.5953C2.95122 10.5318 2.71463 10.5171 2.58293 10.5611Z" />
                </g>
                <defs>
                  <clipPath id="clip0_103_39">
                    <rect
                      width="20"
                      height="10.6061"
                      transform="translate(2 9)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </label>
          </div>
          <div className="form-control mt-6">
            <button
              disabled={!validateEmail(email) && password === "" && name === ""}
              onClick={() => handleRegister()}
              className={
                validateEmail(email) && password !== "" && name !== ""
                  ? "btn btn-primary"
                  : "btn btn-disabled"
              }>
              Register
            </button>
          </div>
          <div className="form-control mt-2">
            <span className="   font-bold text-center label-text">Or</span>
          </div>
          <div className="form-control mt-2">
            <button
              onClick={() => auth.login({ provider: "google" })}
              className="btn text-gray-600 border-0 bg-gray-100 hover:bg-gray-200 flex flex-row w-full  space-x-4 items-center ">
              <svg
                viewBox="0 0 24 24"
                width="24"
                height="24"
                xmlns="http://www.w3.org/2000/svg">
                <g transform="matrix(1, 0, 0, 1, 27.009001, -39.238998)">
                  <path
                    fill="#4285F4"
                    d="M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.229 -9.424 56.479 -10.684 57.329 L -10.684 60.329 L -6.824 60.329 C -4.564 58.239 -3.264 55.159 -3.264 51.509 Z"
                  />
                  <path
                    fill="#34A853"
                    d="M -14.754 63.239 C -11.514 63.239 -8.804 62.159 -6.824 60.329 L -10.684 57.329 C -11.764 58.049 -13.134 58.489 -14.754 58.489 C -17.884 58.489 -20.534 56.379 -21.484 53.529 L -25.464 53.529 L -25.464 56.619 C -23.494 60.539 -19.444 63.239 -14.754 63.239 Z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M -21.484 53.529 C -21.734 52.809 -21.864 52.039 -21.864 51.239 C -21.864 50.439 -21.724 49.669 -21.484 48.949 L -21.484 45.859 L -25.464 45.859 C -26.284 47.479 -26.754 49.299 -26.754 51.239 C -26.754 53.179 -26.284 54.999 -25.464 56.619 L -21.484 53.529 Z"
                  />
                  <path
                    fill="#EA4335"
                    d="M -14.754 43.989 C -12.984 43.989 -11.404 44.599 -10.154 45.789 L -6.734 42.369 C -8.804 40.429 -11.514 39.239 -14.754 39.239 C -19.444 39.239 -23.494 41.939 -25.464 45.859 L -21.484 48.949 C -20.534 46.099 -17.884 43.989 -14.754 43.989 Z"
                  />
                </g>
              </svg>
              <span>Register in with Google</span>
            </button>
          </div>
        </div>
      </AuthWrapper>

      <ScreenLoading open={loading} />
      <BottomNotification
        type={notificationType}
        message={notification}
        rnd={rnd}
      />
    </MainLayout>
  );
};

export default RegisterPage;
